<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Company Name"
                rules="required"
              >
                <TextInput
                  v-model="form.companyName"
                  type="text"
                  :label="$t('companyName')"
                  :tooltipMessage="$t('companyName')"
                  :required="true"
                  :placeholder="$t('enterCompanyName')"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Address Line 1"
                rules="required"
              >
                <TextInput
                  v-model="form.addressLine1"
                  type="text"
                  :label="$t('addressLine1')"
                  :required="true"
                  :placeholder="$t('enterAddressLine1')"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.addressLine2"
                type="text"
                :label="$t('addressLine2')"
                :placeholder="$t('enterAddressLine2')"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="City"
                rules="required"
              >
                <TextInput
                  v-model="form.city"
                  type="text"
                  :label="$t('city')"
                  :required="true"
                  :placeholder="$t('enterCity')"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="ZIP"
                rules="required"
              >
                <TextInput
                  v-model="form.zipCode"
                  type="text"
                  :label="$t('zip')"
                  :required="true"
                  :placeholder="$t('enterZip')"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <label class="form-label input-label" for="country"
                  >{{ $t("country") }}&nbsp;<span style="color: red"
                    >*</span
                  ></label
                >
                <validation-provider
                  #default="{ errors }"
                  name="Country"
                  rules="required"
                >
                  <multi-select
                    :multiple="false"
                    label="name"
                    track-by="name"
                    :options="countries"
                    :key="countries"
                    v-model="form.country"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="4" class="mb-1">
              <TextInput
                v-model="form.vatId"
                type="text"
                :label="$t('vatId')"
                :placeholder="'+123XXXXXX'"
              />
            </b-col>
            <b-col cols="12" lg="4" md="4" class="mb-1">
              <TextInput
                v-model="form.phone"
                type="text"
                :label="$t('phone')"
                placeholder="+49XXXXXXXXXXX"
              />
            </b-col>
            <div class="col-md-4 mb-1">
              <b-form-group class="m-0">
                <label class="input-label form-label"
                  >{{ $t("preferredContactLanguage") }}&nbsp;<span
                    style="color: red"
                    >*</span
                  >
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Contact Language"
                  rules="required"
                >
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                    v-model="form.contactLanguage"
                  >
                    <option
                      v-for="language in languages"
                      :value="language"
                      :key="language"
                    >
                      {{ language }}
                    </option>
                  </select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
            <b-col cols="12" lg="4" md="4" class="mb-1">
              <label class="input-label form-label">{{
                $t("type")
              }}</label>
              <select class="input-form form-control" v-model="form.type">
                <option value="">
                  {{ $t("selectOption") }}
                </option>
                <option value="practice">
                  practice
                </option>
                <option value="lab">
                  lab
                </option>
                <option value="other">
                  other
                </option>
              </select>
            </b-col>
            <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("assignedToSalesPartner") }}&nbsp;<span
                    style="color: red"
                    >*</span
                  >
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Sales Partner"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.salesPartnerId"
                    :key="form.salesPartnerId"
                    :options="salesPartners"
                    label="companyName"
                    trackBy="id"
                    moduleName="customers"
                    :multiple="false"
                    :action="'salesPartners'"
                    :query="{ isSalesPartner: true, isMultiSelect: true }"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("assignedToReseller") }}&nbsp;<span style="color: red"
                    >*</span
                  >
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Reseller"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.resellerId"
                    :key="form.resellerId"
                    :options="resellers"
                    label="companyName"
                    trackBy="id"
                    moduleName="customers"
                    :multiple="false"
                    :action="'resellers'"
                    :query="{ isReseller: true, isMultiSelect: true }"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col> -->
            <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("assignedToServicePartner") }}&nbsp;<span
                    style="color: red"
                    >*</span
                  >
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Service Partner"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.servicePartnerId"
                    :key="form.servicePartnerId"
                    :options="servicePartners"
                    label="companyName"
                    trackBy="id"
                    moduleName="customers"
                    :multiple="false"
                    :action="'servicePartners'"
                    :query="{ isServicePartner: true, isMultiSelect: true }"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col> -->

            <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="cars">{{
                  $t("salesPartner")
                }}</label>

                <input
                  :disabled="!$can('company-sales-partner-check.edit')"
                  id="salesPartner"
                  class="form-check-input-custom ml-2"
                  v-model="form.salesPartner"
                  type="checkbox"
                />
              </div>
            </b-col>
            <!-- <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="cars">{{
                  $t("commercialAgent")
                }}</label>
                <input
                  id="commercialAgent"
                  class="form-check-input-custom ml-2"
                  v-model="form.commercialAgent"
                  type="checkbox"
                />
              </div>
            </b-col> -->
            <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="affiliate">
                  {{ $t("affiliate") }}
                </label>
                <input
                  id="affiliate"
                  class="form-check-input-custom ml-2"
                  v-model="form.affiliate"
                  type="checkbox"
                />
              </div>
            </b-col>
            <b-col cols="12" lg="4" md="4" class="mb-1">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="userGuide">
                  {{ $t("userGuide") }}
                </label>
                <input
                  id="userGuide"
                  class="form-check-input-custom ml-2"
                  v-model="form.userGuide"
                  type="checkbox"
                />
              </div>
            </b-col>
            <!-- <b-col cols="12" lg="3" md="3" class="mb-1">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="cars">{{
                  $t("endUser")
                }}</label>

                <input
                  id="endUser"
                  class="form-check-input-custom ml-2"
                  v-model="form.endUser"
                  type="checkbox"
                />
              </div>
            </b-col> -->
          </b-row>
        </div>
      </div>
      <div class="card">
        <div class="card-header" aria-label="Payment Details Header">
          <h3 class="card-title">
            {{ $t("paymentDetails") }}
          </h3>
        </div>

        <div class="card-body" aria-label="Payment Detials Body">
          <div class="row">
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <text-input
                v-model="form.invoiceEmailAddress"
                :label="$t('invoiceEmailAddress')"
                aria-label="Invoice Email Address Input"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Company Email"
                rules="required"
              >
                <text-input
                  v-model="form.companyEmail"
                  :label="$t('companyEmail')"
                  :required="true"
                  :error="errors[0]"
                  aria-label="Company Email Input"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <text-input
                v-model="form.warningMailAddress"
                :label="$t('warningMailAddress')"
                aria-label="Invoice Email Address Input"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group mt-2">
                <label class="input-label form-label" for="cars">{{
                  $t("applyReverseCharge")
                }}</label>

                <input
                  id="active"
                  class="form-check-input-custom ml-2"
                  v-model="form.applyReverseCharge"
                  type="checkbox"
                />
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <text-input
                v-model="form.externalOrderNumber"
                :label="$t('externalOrderNumber')"
                aria-label="External Order Number"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.pricePerUnit"
                type="number"
                :min="0"
                :label="$t('pricePerUnit')"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.dentawaxPricePerUnit"
                type="number"
                :min="0"
                :label="$t('dentawaxPricePerUnit')"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.dentaTempPricePerUnit"
                type="number"
                :min="0"
                :label="$t('dentaTempPricePerUnit')"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <label class="form-label input-label">
                  {{ $t("payingCurrency") }}
                </label>
                <multi-select
                  v-model="form.payingCurrency"
                  :multiple="false"
                  label="label"
                  track-by="country"
                  :options="countryCurrencies"
                  :placeholder="$t('selectOption')"
                />
              </div>
            </b-col>
            <!-- <b-col cols="12" lg="6" md="6" class="mb-1">
              <text-input
                :type="'number'"
                :disabled="!$can('backoffice-dentaltwin-coins.edit')"
                v-model="form.credits"
                :label="$t('credits')"
                aria-label="Credits"
              />
            </b-col> -->
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <text-input
                v-model="form.notificationMail"
                :label="$t('notificationMail')"
                aria-label="Notification Mail"
              />
            </b-col>
            <!-- <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.freeTestUpperTeeth"
                type="number"
                :label="$t('Free Test Upper Jaw')"
                :tooltipMessage="$t('Free Test Upper Jaw')"
                :required="false"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.freeTestLowerTeeth"
                type="number"
                :label="$t('Free Test Lower Jaw')"
                :tooltipMessage="$t('Free Test Lower Jaw')"
                :required="false"
              />
            </b-col> -->
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.freeCases"
                type="number"
                :label="$t('freeCases')"
                :tooltipMessage="$t('freeCases')"
                :required="false"
              />
            </b-col>
          </div>
        </div>
      </div> <BankDetails v-model="form.bankDetails" />

      <AddUsers @usersListUpdated="handleUsersList" />

      <div class="d-flex align-items-center justify-content-end gap-2">
        <router-link
          to="/customers"
          class="d-flex align-items-center gap-1 btn btn-secondary"
        >
          <feather-icon icon="XIcon" size="12" />
          <span>{{ $t("cancel") }}</span>
        </router-link>
        <b-button
          variant="primary"
          @click="createCustomer"
          class="d-flex align-items-center gap-1"
          :disabled="isFormInvalid"
          v-if="$can(`${$route.meta.permission}.create`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("createCustomer") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import AddUsers from "./components/AddUsers.vue";
import BankDetails from "./components/BankDetails.vue";
import PageHeader from "@/components/PageHeader.vue";
import MultiSelect from "vue-multiselect";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import formDirtyMixin from "@/mixins/formDirtyMixin";
import countries from "@/assets/data/countries.json";
import countryCurrencies from "@/assets/data/country-currencies.json";
import { required, email } from "@validations";
import NotificationService from "@/services/notification.service";

export default {
  components: {
    TextInput,
    PageHeader,
    MultiSelect,
    ValidationProvider,
    MultiSelectInput,
    ValidationObserver,
    AddUsers,
    BankDetails
  },
  computed: {
    ...mapGetters("customers", [
      "resellers",
      "salesPartners",
      "servicePartners",
    ]),
    ...mapGetters("globalConfiguration", ["configuration"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("customers"),
          to: "/customers",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.companyName ||
        !this.form.addressLine1 ||
        !this.form.city ||
        !this.form.zipCode ||
        !this.form.country ||
        // !this.form.resellerId ||
        !this.form.salesPartnerId ||
        this.usersList.length == 0
      );
    },
  },
  mixins: [formDirtyMixin],
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  async created() {
    try {
      this.$store.commit("showLoader", true);
      // await this.$store.dispatch("customers/resellers", {
      //   isReseller: true,
      //   isMultiSelect: true,
      // });
      await this.$store.dispatch("customers/salesPartners", {
        isSalesPartner: true,
        isMultiSelect: true,
      });
      // await this.$store.dispatch("customers/servicePartners", {
      //   isServicePartner: true,
      //   isMultiSelect: true,
      // });
      await this.$store.dispatch("globalConfiguration/show");
      this.form.freeCases = this.configuration?.freeCases ?? "";
      this.$store.dispatch("customers/getResellerPartner").then((res) => {
        let data = res?.data;
        this.form.salesPartnerId = data?.salesPartnerCompany;
        // this.form.resellerId = data?.resellerCompany;
        // this.form.servicePartnerId = data?.servicePartnerCompany;
        this.originalForm = JSON.stringify(this.form);
      });
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
  data() {
    return {
      countries,
      countryCurrencies,
      languages: [
        "English",
        "French",
        "German",
        "Spanish",
        "Turkish",
      ],
      originalForm: null,
      usersList: [],
      owners: [],
      form: {
        companyName: "",
        companyEmail: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        zipCode: "",
        country: "",
        vatId: "",
        phone: "",
        contactLanguage: "English",
        type: "",
        // credits: "",
        bankDetails: [],
        // resellerId: "",
        // servicePartnerId: "",
        salesPartnerId: "",
        externalOrderNumber: "",
        pricePerUnit: "",
        dentawaxPricePerUnit: "",
        dentaTempPricePerUnit: "",
        payingCurrency: null,
        invoiceEmailAddress: "",
        warningMailAddress: "",
        applyReverseCharge: false,
        // reseller: false,
        // endUser: false,
        salesPartner: false,
        // commercialAgent: false,
        affiliate: false,
        userGuide: false,
        notificationMail: "",
        freeCases: "",
        freeTestLowerTeeth: "",
        freeTestUpperTeeth: "",
      },
    };
  },

  methods: {
    handleUsersList(updatedList) {
      this.usersList = updatedList;
    },
    async createCustomer() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          if (this.usersList.length > 0) {
            this.$store.commit("showLoader", true);
            let response = await this.$store.dispatch("customers/create", {
              ...this.form,
              companyEmail: this.form.companyEmail || null,
              type: this.form.type || null,
              country: this.form.country?.name ?? "",
              salesPartnerId: this.form.salesPartnerId?.id ?? "",
              payingCurrency: this.form.payingCurrency?.currency ?? null,
              // resellerId: this.form.resellerId?.id ?? "",
              // servicePartnerId: this.form.servicePartnerId?.id ?? "",
            });

            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);

            const companyId = response?.data?.data?.id;
            for (const user of this.usersList) {
              const usersResponse = await this.$store.dispatch("users/create", {
                ...user,
                company_id: companyId,
                set_company_id: companyId,
              });
              if (usersResponse?.data?.id) {
                this.owners.push(usersResponse.data.id);
              }
            }

            await this.$store.dispatch("customers/saveCompanyOwners", {
              owners: this.owners,
              companyId: companyId,
            });

            this.$store.commit("showLoader", false);
            
            this.$router.push("/customers");

          } else {
            NotificationService.showError(
              "Please assign at least one user to this company"
            );
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
